/* eslint-disable */
export default {
  unknown: 'Onbekend',
  anonymous: 'Anoniem',
  activeCalls: 'Alle oproepen',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCalls"@#@ @source: @#@"All Calls"@#@
